import DataListBulkActionsContext from "@magicware/data-lists/DataListBulkActionsContext";
import { MenuAction } from "@magicware/data-lists/DataListContextMenu";
import { useTranslation } from "react-i18next";
import { useAppInstaceNavigation } from "../../navigation/appInstances";
import { useNewItemMenuAction } from "../../navigation/hooks";

export default function AppInstanceListMenuContext(props: { children?: React.ReactNode }) {
    const { t } = useTranslation();
    const actions: MenuAction[] = [];
    const [parentId, navigation] = useAppInstaceNavigation();
    const addAction = useNewItemMenuAction(t("add-app"), () => navigation.new.url(parentId));
    return (
        <DataListBulkActionsContext defaultAction={addAction} actions={actions}>
            {props.children}
        </DataListBulkActionsContext>
    );
}
